export default "__VITE_ASSET__BLNQu$xx__"